/**
 * The money formatter for every POS screen (final-review F5: this file previously claimed to be
 * "the only" one in this client -- it is not; `components/dashboard/registry/format.ts` has its
 * own `fmtMoney` + `CURRENCY_SYMBOL` for the non-POS dashboard widgets, predating this file. The
 * two happen to agree today -- both pin `en-US`, both 2dp, both prefix `৳` -- but that is not
 * enforced anywhere, so a future change to one must not be assumed to reach the other). POS money
 * is BigDecimal(19,4) on the wire, so values may arrive as a number or a string; both forms are
 * parsed through `Number` and rendered to 2dp for display only. This is exact for every realistic
 * retail amount and only loses precision past `Number.MAX_SAFE_INTEGER` (2^53-1) -- the string
 * form is accepted for JSON-shape convenience, not because it is parsed any more precisely than a
 * number would be. Never do arithmetic on the result.
 */
export const formatMoney = (value: string | number | null | undefined): string => {
    if (value === null || value === undefined || value === '') return '—';
    const n = typeof value === 'string' ? Number(value) : value;
    if (Number.isNaN(n)) return '—';
    const sign = n < 0 ? '-' : '';
    const body = Math.abs(n).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    return `${sign}৳${body}`;
};
